export const WEBSITE_MAX_LENGTH = 100;
export const TELEGRAM_MAX_LENGTH = 50;
export const EMAIL_MAX_LENGTH = 50;
export const NICKNAME_MAX_LENGTH = 30;
export const TWITTER_MAX_LENGTH = 100;

const TELEGRAM_REGEX = [
    /^https:\/\/t\.me\/[a-zA-Z0-9_]+$/,
    // /^(?:|(https?:\/\/)?(|www)[.]?((t|telegram)\.me)\/)[a-zA-Z0-9_]{5,32}$/gm,
    // /^@[a-zA-Z0-9_]+$/
];
export const EMAIL_REGEX = [
    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/
];
const TWITTER_REGEX = [
    /http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/
];

export enum VALIDATE_LINK_TYPES {
    telegram = 'telegram',
    website = 'website',
    email = 'email',
    twitter = 'twitter',
}

const VALIDATE_LINKS_ENTITY: Record<VALIDATE_LINK_TYPES, { length: number, regex: RegExp[] }> = {
    [VALIDATE_LINK_TYPES.telegram]: {
        length: TELEGRAM_MAX_LENGTH,
        regex: TELEGRAM_REGEX,
    },
    [VALIDATE_LINK_TYPES.website]: {
        length: WEBSITE_MAX_LENGTH,
        regex: [],
    },
    [VALIDATE_LINK_TYPES.email]: {
        length: EMAIL_MAX_LENGTH,
        regex: EMAIL_REGEX,
    },
    [VALIDATE_LINK_TYPES.twitter]: {
        length: TWITTER_MAX_LENGTH,
        regex: TWITTER_REGEX,
    },
}

export const checkLinkForErrors = (link: string, linkType: VALIDATE_LINK_TYPES): '' | 'length' | 'invalid' => {

    if (link.length === 0) return '';
    if (link.length > VALIDATE_LINKS_ENTITY[linkType].length) return 'length';

    if (linkType === VALIDATE_LINK_TYPES.website) {
        try {
            new URL(link);
            return '';
        } catch (err) {
            return 'invalid';
        }
    }

    return VALIDATE_LINKS_ENTITY[linkType]?.regex.some(regex => regex.test(link)) ? '' : 'invalid';
}

export const validateNickName = (nickName: string, t: any) => {
    const error = [t('designer_edit.nickname.nickname_error_part1')];

    if(!nickName?.match(/^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*$/)) {
        error.push(t('designer_edit.nickname.nickname_error_part2'));
    }
    if(nickName && nickName?.length > NICKNAME_MAX_LENGTH) {
        if(error?.length > 1) {
            error.push(t('designer_edit.nickname.nickname_error_part4'));
        } else {
            error.push(t('designer_edit.nickname.nickname_error_part3'));
        }
    }
    if(nickName && nickName?.trim().length < 3) {
        if(error?.length > 1) {
            error.push(t('designer_edit.nickname.nickname_error_part6'));
        } else {
            error.push(t('designer_edit.nickname.nickname_error_part5'));
        }
    }

    if(error?.length > 1) {
        return error.join('');
    }

    return false
}

export const validatePassword = (password: string, t: any) => {
    let hasNoLen = false
    const error = [t('designer_edit.password.password_error_part1')]
    const onePref = t('designer_edit.password.password_error_part2')

    if(!password?.match(/(?=.*?[A-Z])/)) {
        hasNoLen = true
        error.push(onePref)
        error.push(t('designer_edit.password.password_error_part3'))
    }
    if(!password?.match(/(?=.*?[a-z])/)) {
        if(!hasNoLen) {
            hasNoLen = true
            error.push(onePref)
            error.push(t('designer_edit.password.password_error_part4'))
        } else {
            error.push(t('designer_edit.password.password_error_part5'))
        }
    }
    if(!password?.match(/(?=.*?[0-9])/)) {
        if(!hasNoLen) {
            hasNoLen = true
            error.push(onePref)
            error.push(t('designer_edit.password.password_error_part6'))
        } else {
            error.push(t('designer_edit.password.password_error_part7'))
        }
    }
    if(!password?.match(/[#\?\!\@\$\%\^\&\*\+\-~'_,.:;"\`\=\|\)\(\}\{\]\[]/)) {
        if(!hasNoLen) {
            hasNoLen = true
            error.push(onePref)
            error.push(t('designer_edit.password.password_error_part8'))
        } else {
            error.push(t('designer_edit.password.password_error_part9'))
        }
    }
    if(password && password?.length < 6) {
        if(!hasNoLen) {
            hasNoLen = true
            error.push(t('designer_edit.password.password_error_part10'))
        } else {
            error.push(t('designer_edit.password.password_error_part11'))
        }
    }

    if(error?.length > 1) {
        return error.join('');
    }

    return false
}export const WEBSITE_MAX_LENGTH = 100;
export const TELEGRAM_MAX_LENGTH = 50;
export const EMAIL_MAX_LENGTH = 50;
export const NICKNAME_MAX_LENGTH = 30;
export const TWITTER_MAX_LENGTH = 100;

const TELEGRAM_REGEX = [
    /^https:\/\/t\.me\/[a-zA-Z0-9_]+$/,
    // /^(?:|(https?:\/\/)?(|www)[.]?((t|telegram)\.me)\/)[a-zA-Z0-9_]{5,32}$/gm,
    // /^@[a-zA-Z0-9_]+$/
];
export const EMAIL_REGEX = [
    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/
];
const TWITTER_REGEX = [
    /http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/
];

export enum VALIDATE_LINK_TYPES {
    telegram = 'telegram',
    website = 'website',
    email = 'email',
    twitter = 'twitter',
}

const VALIDATE_LINKS_ENTITY: Record<VALIDATE_LINK_TYPES, { length: number, regex: RegExp[] }> = {
    [VALIDATE_LINK_TYPES.telegram]: {
        length: TELEGRAM_MAX_LENGTH,
        regex: TELEGRAM_REGEX,
    },
    [VALIDATE_LINK_TYPES.website]: {
        length: WEBSITE_MAX_LENGTH,
        regex: [],
    },
    [VALIDATE_LINK_TYPES.email]: {
        length: EMAIL_MAX_LENGTH,
        regex: EMAIL_REGEX,
    },
    [VALIDATE_LINK_TYPES.twitter]: {
        length: TWITTER_MAX_LENGTH,
        regex: TWITTER_REGEX,
    },
}

export const checkLinkForErrors = (link: string, linkType: VALIDATE_LINK_TYPES): '' | 'length' | 'invalid' => {

    if (link.length === 0) return '';
    if (link.length > VALIDATE_LINKS_ENTITY[linkType].length) return 'length';

    if (linkType === VALIDATE_LINK_TYPES.website) {
        try {
            new URL(link);
            return '';
        } catch (err) {
            return 'invalid';
        }
    }

    return VALIDATE_LINKS_ENTITY[linkType]?.regex.some(regex => regex.test(link)) ? '' : 'invalid';
}

export const validateNickName = (nickName: string, t: any) => {
    const error = [t('designer_edit.nickname.nickname_error_part1')];

    if(!nickName?.match(/^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*$/)) {
        error.push(t('designer_edit.nickname.nickname_error_part2'));
    }
    if(nickName && nickName?.length > NICKNAME_MAX_LENGTH) {
        if(error?.length > 1) {
            error.push(t('designer_edit.nickname.nickname_error_part4'));
        } else {
            error.push(t('designer_edit.nickname.nickname_error_part3'));
        }
    }
    if(nickName && nickName?.trim().length < 3) {
        if(error?.length > 1) {
            error.push(t('designer_edit.nickname.nickname_error_part6'));
        } else {
            error.push(t('designer_edit.nickname.nickname_error_part5'));
        }
    }

    if(error?.length > 1) {
        return error.join('');
    }

    return false
}

export const validatePassword = (password: string, t: any) => {
    let hasNoLen = false
    const error = [t('designer_edit.password.password_error_part1')]
    const onePref = t('designer_edit.password.password_error_part2')

    if(!password?.match(/(?=.*?[A-Z])/)) {
        hasNoLen = true
        error.push(onePref)
        error.push(t('designer_edit.password.password_error_part3'))
    }
    if(!password?.match(/(?=.*?[a-z])/)) {
        if(!hasNoLen) {
            hasNoLen = true
            error.push(onePref)
            error.push(t('designer_edit.password.password_error_part4'))
        } else {
            error.push(t('designer_edit.password.password_error_part5'))
        }
    }
    if(!password?.match(/(?=.*?[0-9])/)) {
        if(!hasNoLen) {
            hasNoLen = true
            error.push(onePref)
            error.push(t('designer_edit.password.password_error_part6'))
        } else {
            error.push(t('designer_edit.password.password_error_part7'))
        }
    }
    if(!password?.match(/[#\?\!\@\$\%\^\&\*\+\-~'_,.:;"\`\=\|\)\(\}\{\]\[]/)) {
        if(!hasNoLen) {
            hasNoLen = true
            error.push(onePref)
            error.push(t('designer_edit.password.password_error_part8'))
        } else {
            error.push(t('designer_edit.password.password_error_part9'))
        }
    }
    if(password && password?.length < 6) {
        if(!hasNoLen) {
            hasNoLen = true
            error.push(t('designer_edit.password.password_error_part10'))
        } else {
            error.push(t('designer_edit.password.password_error_part11'))
        }
    }

    if(error?.length > 1) {
        return error.join('');
    }

    return false
}